export const Table = ({
  displayedData,
  currentPage,
  itemsPerPage,
  filteredData,
  handleNextPage,
  handlePrevPage,
  totalPages,
  onAcmtEdit,
  onCertDownload,
  onAcmtDelete,
}) => {
  const shortenCertificateName = (filePath) => {
    if (!filePath) return "-";
    const fileName = filePath.split("/certificates/")[1];
    if (!fileName) return filePath;
    const maxLength = 15;
    const fileExt = fileName.split(".").pop();
    if (fileName.length <= maxLength) return `/certificates/${fileName}`;
    return `/certificates/${fileName.substring(0, 5)}....${fileExt}`;
  };

  return (
    <>
      <div className="overflow-auto shadow-md p-4 w-full rounded h-auto overflow-x-auto">
        <table className="rounded-sm w-full">
          <thead className="bg-blue-100 text-nowrap p-2 text-gray-700">
            <tr className="p-1">
              <th className="py-3 px-4">#</th>
              <th className="py-3 px-4">Nama Lembaga</th>
              <th className="py-3 px-4">Nama Peserta</th>
              <th className="py-3 px-4">Kelas</th>
              <th className="py-3 px-4">Nama Lomba</th>
              <th className="py-3 px-4">Penyelenggara</th>
              <th className="py-3 px-4">Tanggal Lomba</th>
              <th className="py-3 px-4">Tingkat</th>
              <th className="py-3 px-4">Juara</th>
              <th className="py-3 px-4">Link Sertifikat</th>
              <th className="py-3 px-4">Aksi</th>
            </tr>
          </thead>
          <tbody>
            {displayedData.map((data, i) => {
              const date = new Date(data.competition_date);
              const day = String(date.getDate()).padStart(2, "0");
              const month = String(date.getMonth() + 1).padStart(2, "0");
              const year = date.getFullYear();
              const formattedDate = `${day}/${month}/${year}`;

              return (
                <tr
                  key={i}
                  className="hover:bg-slate-50 border-b border-slate-200"
                >
                  <td className="py-3 px-4">
                    {(currentPage - 1) * itemsPerPage + i + 1}
                  </td>
                  <td className="py-3 px-4">{data.school_name || "-"}</td>
                  <td className="py-3 px-4">{data.participant_name}</td>
                  <td className="py-3 px-4">{data.class}</td>
                  <td className="py-3 px-4">{data.competition_name}</td>
                  <td className="py-3 px-4">{data.organizer}</td>
                  <td className="py-3 px-4">{formattedDate}</td>
                  <td className="py-3 px-4">{data.competition_level}</td>
                  <td className="py-3 px-4">{data.achievement_rank}</td>
                  <td className="py-3 px-4">
                    {shortenCertificateName(data.certificate_file)}
                  </td>
                  <td className="py-3 px-4 flex flex-row gap-1 flex-wrap">
                    <button
                      onClick={() => onCertDownload(data.certificate_file)}
                      className="flex-grow flex gap-1 flex-row items-center justify-between px-1.5 py-0.1 text-white rounded bg-green-500 hover:bg-green-600 "
                    >
                      <span className="text-sm material-symbols-outlined">
                        download
                      </span>
                      Unduh Sertifikat
                    </button>
                    <button
                      onClick={() => onAcmtEdit(data)}
                      className="flex-grow flex gap-1 flex-row items-center justify-between px-1.5 py-0.1 text-white rounded bg-blue-500 hover:bg-blue-600 "
                    >
                      <span className="text-sm material-symbols-outlined">
                        edit
                      </span>
                      Edit
                    </button>
                    <button
                      onClick={() =>
                        onAcmtDelete(data.id, data.certificate_file)
                      }
                      className="flex-grow flex gap-1 flex-row items-center justify-between px-1.5 py-0.1 text-white rounded bg-red-500 hover:bg-red-600 "
                    >
                      <span className="text-sm material-symbols-outlined">
                        delete
                      </span>
                      Hapus
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div className="flex justify-between items-center px-4 py-3">
        <div className="text-sm text-slate-500">
          <b>{(currentPage - 1) * itemsPerPage + 1}</b> -{" "}
          <b>{Math.min(currentPage * itemsPerPage, filteredData.length)}</b> of{" "}
          <b>{filteredData.length}</b>
        </div>
        <div className="flex space-x-1">
          <button
            onClick={handlePrevPage}
            className="px-3 py-1 text-sm font-normal text-slate-500 bg-white border border-slate-200 rounded hover:bg-slate-50 hover:border-slate-400"
            disabled={currentPage === 1}
          >
            Prev
          </button>
          <button
            onClick={handleNextPage}
            className="px-3 py-1 text-sm font-normal text-slate-500 bg-white border border-slate-200 rounded hover:bg-slate-50 hover:border-slate-400"
            disabled={currentPage === totalPages}
          >
            Next
          </button>
        </div>
      </div>
    </>
  );
};
